import { render, staticRenderFns } from "./EditLivraison.vue?vue&type=template&id=15ee2138&"
import script from "./EditLivraison.vue?vue&type=script&lang=ts&"
export * from "./EditLivraison.vue?vue&type=script&lang=ts&"
import style0 from "./EditLivraison.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports